import { Skeleton } from "@/design-system";

export function RouteLoading() {
  return (
    <main id="main-content" className="route-loading" tabIndex={-1}>
      <p className="route-loading__status" role="status">
        در حال بارگذاری صفحه…
      </p>
      <div className="route-loading__preview" aria-hidden="true">
        <div className="route-loading__copy">
          <Skeleton className="route-loading__placeholder" w="32%" h="var(--ds-space-16)" />
          <Skeleton className="route-loading__placeholder" w="88%" h="var(--ds-space-32)" />
          <Skeleton className="route-loading__placeholder" w="64%" h="var(--ds-space-32)" />
          <Skeleton className="route-loading__placeholder" lines={3} h="var(--ds-space-12)" />
          <Skeleton className="route-loading__placeholder" w="48%" h="var(--app-touch-target)" />
        </div>
        <Skeleton
          className="route-loading__placeholder route-loading__visual"
          w="100%"
          h="clamp(12rem, 30svh, 24rem)"
          radius="var(--ds-radius-xl)"
        />
      </div>
    </main>
  );
}
